import { render } from "./DetailInvoice.vue?vue&type=template&id=6f004cc2"
import script from "./DetailInvoice.vue?vue&type=script&lang=js"
export * from "./DetailInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__